import { useEffect, useState } from 'react'
import { I18nProvider } from '@lingui/react'
import { i18n } from '@lingui/core'
import { Stack, Text, Title } from '@mantine/core'
import App from './App.tsx'
import { BossMantineProvider } from '@m3-tech/boss-ui'
import { detectLocale, loadCatalog } from './i18n'

type LoadState = { status: 'loading' } | { status: 'ready' } | { status: 'error' }

export function I18nApp() {
    const [state, setState] = useState<LoadState>({ status: 'loading' })

    useEffect(() => {
        const locale = detectLocale()
        loadCatalog(locale)
            .then(() => setState({ status: 'ready' }))
            .catch((err) => {
                console.error('Failed to load i18n catalog', err)
                setState({ status: 'error' })
            })
    }, [])

    if (state.status === 'loading') {
        return null
    }

    // i18n catalog failed to load — render a Mantine-only fallback (Trans/t
    // are unavailable here, so we ship English as a last resort) and let the
    // user know to refresh.
    if (state.status === 'error') {
        return (
            <BossMantineProvider>
                <Stack role="alert" align="center" gap="sm" p="xl" ta="center">
                    <Title order={3}>Unable to load translations</Title>
                    <Text c="dimmed">Please refresh the page to try again.</Text>
                </Stack>
            </BossMantineProvider>
        )
    }

    return (
        <I18nProvider i18n={i18n}>
            <BossMantineProvider>
                <App />
            </BossMantineProvider>
        </I18nProvider>
    )
}
